import { AfterViewInit, Component, OnChanges, OnInit, SimpleChanges } from "@angular/core";
import { SelectItem } from "primeng/api";
import { PrimengDataSet } from "src/app/models/response/artistoverlaydashboard.model";
import { GalleryInsightsMetricsColors, GallerySalesChartResponse, GallerySalesInsightsMetrics, GallerySalesInsightsMetricsType } from "src/app/models/response/galleryDashboard.models";
import { AuthConfig, AuthService } from "src/app/Services/auth.service";
import { DashboardService } from "src/app/Services/dashboard.service";

@Component({
    selector: 'gallery-insights-charts',
    templateUrl: './gallery-insights-charts.component.html',
    inputs: ['insightsSeriesData', 'selectedTabIndex'],
    standalone: false
})

export class GalleryInsightChartComponent implements OnInit, OnChanges,AfterViewInit{
    public selectedGalleryProductSalesDuration:  number = 365 ;
    public GalleryProductSalesDuration: SelectItem[] = [
        { label: 'Last 1 week', value: 7 },
        { label: 'Last 1 month', value: 30 },
        { label: 'Last 3 months', value: 90 },
        { label: 'Last 6 months', value: 180 },
        { label: 'Last 1 year', value: 365 }
    ];
    public gallerySaleRevenueData: any;
    public gallerySalesDataLoaded: boolean = false;
    public insightsSeriesChartOptions: any;
    public insightsSeriesData!: GallerySalesChartResponse;
    public selectedTabIndex!: number;
    public insightsGalleryChartData!: PrimengDataSet;
    public isAuthenticated!: boolean;
    public isGallery: boolean = false;
    public authConfig: AuthConfig = {}
    
    constructor(private dashboardService:DashboardService,private authService:AuthService){

    }
    ngOnInit(): void {
        this.authConfig = this.authService.getAuthConfig();
        this.isAuthenticated = this.authService.isAuthenticated();
        if (this.isAuthenticated) {
        this.authConfig = this.authService.getAuthConfig();
        this.isGallery = this.authConfig.IsGallery || false;
        }

        const documentStyle = getComputedStyle(document.documentElement);
        const textColor = documentStyle.getPropertyValue('--text-color');
        const textColorSecondary = documentStyle.getPropertyValue('--text-color-secondary');
        const surfaceBorder = documentStyle.getPropertyValue('--surface-border');
        this.insightsSeriesChartOptions = {
            maintainAspectRatio: false,
            aspectRatio: 0.6,
            plugins: {
                legend: {
                    labels: {
                        color: textColor,
                    }
                },
                tooltip: {
                    callbacks: {
                        //https://www.chartjs.org/docs/latest/configuration/tooltip.html#tooltip-callbacks
                        label: function (context: { dataset: { label: string; }; }) {
                            let label = context.dataset.label || '';
                            //you can add any customizations to the label here
                            return label;
                        },
                        title: function (tooltipItems: string | any[]) {
                            if (tooltipItems && tooltipItems.length > 0) {
                                var item = tooltipItems[0];
                                var index = item.dataIndex;
                                if (index >= 0 && item.dataset) {
                                    var dataset = item.dataset;
                                    console.log(dataset);
                                    return dataset.dataPointLabels[index] + ': ' + dataset.data[index];
                                }
                            }
                            return null;
                        }
                    }
                }
            },
        };
        this.gallerySalesDataLoaded = true;
    }

    ngOnChanges(changes: SimpleChanges): void {
        if(changes['insightsSeriesData'] && changes['insightsSeriesData'].isFirstChange() && this.insightsSeriesData){
           this.getChartData(this.insightsSeriesData);
        //    console.log("onchange",this.insightsSeriesData)
        }
        if(changes['selectedTabIndex'] && !changes['selectedTabIndex'].isFirstChange()){
            // console.log(this.selectedTabIndex)
        }
    }

    ngAfterViewInit(): void {
        this.getChartData(this.insightsSeriesData)
    }
    
    public getChartData(insightsChartsData: GallerySalesChartResponse) {
        const documentStyle = getComputedStyle(document.documentElement);
        if(insightsChartsData.ChartsValue){
            this.insightsGalleryChartData= {
                labels: insightsChartsData.ChartsValue.map(p=>p.Label),
                datasets: [
                    {
                        label: insightsChartsData.SeriesName,
                        data: insightsChartsData.ChartsValue.map((data) => data.Value),
                        dataPointLabels: insightsChartsData.ChartsValue.map((data)=>data.DataLabel),
                        fill: insightsChartsData.Metric == GallerySalesInsightsMetrics.TotalSalesRevenue || insightsChartsData.Metric == GallerySalesInsightsMetrics.TotalProductSold,
                        borderColor: documentStyle.getPropertyValue(this.getSeriesColor(insightsChartsData.Metric)),
                        tension: 0.4,
                    },
                ],
            }
            // console.log("p-chart",this.insightsGalleryChartData)
            this.gallerySalesDataLoaded = true
        }
        // this.totalValues = this.insightsSeriesData

    }
    
    private getSeriesColor(seriesName: GallerySalesInsightsMetricsType): string {
        if (seriesName == GallerySalesInsightsMetrics.TotalSalesRevenue) {
            return GalleryInsightsMetricsColors.TotalSalesRevenue;
        } else if (seriesName == GallerySalesInsightsMetrics.TotalProductSold) {
            return GalleryInsightsMetricsColors.TotalProductSold;
        } 
        return '--blue-500';
    }
     
    calculateTotalSales(): number {
        if (!this.insightsSeriesData || !this.insightsSeriesData.ChartsValue) {
            return 0;
        }
    
        return this.insightsSeriesData.ChartsValue.reduce((total, value) => total + value.Value, 0);
    }

    public onSalesDurationChange($event: any) {
         // console.log($event)
         if($event.value){
            const seletedValue = $event.value
        this.selectedGalleryProductSalesDuration = seletedValue
        // console.log(this.selectedArtristProductDetailDuration)
        this.dashboardService.getSubscriptionDurationGallery(this.selectedGalleryProductSalesDuration).subscribe((durationValue: GallerySalesChartResponse[]) =>{
            // console.log(durationValue)
            // this.insightsSeriesData = durationValue[1];
            if(this.selectedTabIndex == 0 && durationValue.find(p=>p.Metric == GallerySalesInsightsMetrics.TotalSalesRevenue)){
                this.insightsSeriesData = durationValue[0]
            }else if(this.selectedTabIndex == 1 && durationValue.find(p=>p.Metric == GallerySalesInsightsMetrics.TotalProductSold)){
                this.insightsSeriesData = durationValue[1]
            }
            // console.log(this.insightsInputData)
            // console.log("onduration",this.insightsSeriesData)
            if(this.isGallery){
                this.getChartData(this.insightsSeriesData)
            }
        })
        }else{
            // this.selectedArtristProductDetailDuration = 365
        }
    }
}